import PropTypes from "prop-types";
import styled from "styled-components";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import { IconClose } from "assets/icons";
import { BlueCheckIcon } from "assets/icons";

const ValidationContainer = styled(Popover)`
  &.popover {
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    background: ${({ theme }) => theme.dropdown.bg.popover};

    .popover-body {
      .validator {
        &:last-child {
          margin-bottom: 0;
        }
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .validation-item {
          margin-bottom: 0;
          margin-left: 10px;
        }
      }
    }

    .popover-header,
    .popover-body {
      color: ${({ theme }) => theme.global.extraInfo.font.color};
    }
    .popover-arrow {
      ::after {
        border-bottom-color: ${({ theme }) => theme.dropdown.bg.popover};
      }
    }
  }
`;

const popover = (errors = []) => (
  <ValidationContainer id="valid_popover">
    <Popover.Body>
      <div className="validation">
        {errors.map((err) => (
          <span className="validator" key={err.label}>
            {err.verified && (
              <BlueCheckIcon
                stroke="green"
                height={20}
                width={16}
                viewBox="0 0 22 20"
                strokeWidth="2.5"
              />
            )}
            {!err.verified && (
              <IconClose
                fill="red"
                height={16}
                width={16}
                viewBox="0 0 22 20"
              />
            )}
            <p className="validation-item">{err.label}</p>
          </span>
        ))}
      </div>
    </Popover.Body>
  </ValidationContainer>
);

export const PasswordValidationPopup = ({ children, errors = [] }) => {
  return (
    <OverlayTrigger
      rootClose
      trigger={["click"]}
      placement="bottom"
      delay={{ show: 100, hide: 200 }}
      overlay={
        Array.isArray(errors) && errors.length ? popover(errors) : <span />
      }
    >
      <span>{children}</span>
    </OverlayTrigger>
  );
};

PasswordValidationPopup.propTypes = {
  children: PropTypes.node,
  errors: PropTypes.array,
};
